import React, { Suspense } from 'react';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import i18n from "i18next";
import { Loading } from "./pages/loading";
import { createRoot } from 'react-dom/client';



const container = document.getElementById('root');
const root = createRoot(container);
root.render( <App /> );



reportWebVitals();


